var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRandom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    fill: "#A7ABB0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.83398 9.02539H7.91211L6.9082 7.3457C6.70768 7.00977 6.52409 6.7819 6.35742 6.66211C6.19076 6.53971 5.99154 6.47852 5.75977 6.47852H5.19727V9.02539H4.41602V2.97461H6.25977C6.84831 2.97461 7.30924 3.11654 7.64258 3.40039C7.97591 3.68424 8.14258 4.08138 8.14258 4.5918C8.14258 5.43034 7.69466 5.97461 6.79883 6.22461V6.24414C6.96549 6.31445 7.10872 6.41471 7.22852 6.54492C7.35091 6.67513 7.50846 6.89779 7.70117 7.21289L8.83398 9.02539ZM5.19727 3.6582V5.79492H6.11914C6.47591 5.79492 6.76497 5.69076 6.98633 5.48242C7.21029 5.27409 7.32227 5.00065 7.32227 4.66211C7.32227 4.34701 7.2207 4.10091 7.01758 3.92383C6.81445 3.74674 6.51888 3.6582 6.13086 3.6582H5.19727Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRandom);
export default __webpack_public_path__ + "static/media/random.04ff0ec431e09845217806c02a38473f.svg";
export { ForwardRef as ReactComponent };